<template>
  <div class="card-padding histogram">
    <div class="header">
      <div class="main">
        帮助文档
      </div>
    </div>
    <div class="body">
      <div class="link-list">
        <a
          target="_blank"
          href="https://shopex.yuque.com/books/share/116d5ca3-e9c0-4b66-9953-36201822d4f9?#"
        >· 产品使用手册</a>
      </div>
      <div class="link-list">
        <a
          target="_blank"
          href="https://shopex.yuque.com/books/share/0dfb4bb7-dc87-4bb6-9bd1-27f292daf97f?#"
        >· 版本更新通知</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {}
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.histogramContent {
  width: 100%;
  transition: all 0.3s ease-in;
}
.card-padding {
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;

  &.histogram {
    .main {
      font-size: 18px;
      color: black;
      font-weight: 500;
    }
    .sub {
      font-size: 12px;
      color: grey;
    }
    .body {
      margin-top: 15px;
    }
  }
}
@media only screen and (max-width: 1600px) {
  .histogram {
    .main {
      font-size: 14px;
    }
  }
}
.link-list {
  line-height: 24px;
}
</style>
